import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const learn = {
  name: 'admin.learn',
  path: 'learn',
  component: () => import('pages/Learning.vue'),
  redirect: { name: 'admin.learn.dashboard' },
  meta: {
    roles: [
      Roles.SuperAdmin,
      Roles.OrgAdmin,
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.RoomStaff,
    ],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
  children: [
    {
      name: 'admin.learn.dashboard',
      path: '',
      component: () => import('components/learn/DashboardIndex.vue'),
      meta: {
        roles: [
          Roles.SuperAdmin,
          Roles.OrgAdmin,
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.RoomStaff,
        ],
      },
    },
    {
      name: 'admin.learn.plan',
      path: 'plan',
      component: () => import('components/learn/PlansIndex.vue'),
      redirect: { name: 'admin.learn.plan.index' },
      meta: {
        roles: [
          Roles.SuperAdmin,
          Roles.OrgAdmin,
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.RoomStaff,
        ],
      },
      children: [
        {
          name: 'admin.learn.plan.index',
          path: '',
          component: () => import('components/learn/plan/LessonPlanSelect.vue'),
        },
        {
          name: 'admin.learn.plan.create',
          path: 'create',
          component: () => import('components/learn/plan/LessonPlanForm.vue'),
          meta: {
            centerSwitchRedirect: { name: 'admin.learn.plan.index' },
          },
        },
        {
          name: 'admin.learn.plan.edit',
          path: ':planId',
          component: () => import('components/learn/plan/LessonPlanForm.vue'),
          meta: {
            centerSwitchRedirect: { name: 'admin.learn.plan.index' },
          },
        },
        {
          name: 'admin.learn.plan.view',
          path: ':planId/view',
          component: () =>
            import('components/learn/plan/readonly/LessonPlanReadonlyView.vue'),
          meta: {
            centerSwitchRedirect: { name: 'admin.learn.plan.index' },
          },
        },
      ],
    },
    {
      name: 'admin.learn.lesson',
      path: 'lesson',
      component: () => import('components/learn/LessonsIndex.vue'),
      meta: {
        roles: [
          Roles.SuperAdmin,
          Roles.OrgAdmin,
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.RoomStaff,
        ],
        centerSwitchRedirect: { params: { lessonId: null } },
      },
    },
    {
      name: 'admin.learn.report',
      path: 'report',
      component: () => import('components/learn/ReportsIndex.vue'),
      redirect: { name: 'admin.learn.report.index' },
      meta: {
        roles: [
          Roles.SuperAdmin,
          Roles.OrgAdmin,
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.RoomStaff,
        ],
      },
      children: [
        {
          name: 'admin.learn.report.index',
          path: '',
          component: () => import('components/learn/ReportsIndex.vue'),
        },
        {
          name: 'admin.learn.report.focusArea',
          path: 'focusArea',
          component: () =>
            import('components/learn/reports/focusArea/FocusAreaIndex.vue'),
          redirect: { name: 'admin.learn.report.focusArea.index' },
          children: [
            {
              name: 'admin.learn.report.focusArea.index',
              path: '',
              component: () =>
                import('components/learn/reports/focusArea/FocusAreaIndex.vue'),
              meta: {
                centerSwitchRedirect: { name: 'admin.learn.report.index' },
              },
            },
            {
              name: 'admin.learn.report.focusAreaStudent',
              path: 'student',
              component: () =>
                import('components/learn/reports/focusArea/FocusAreaStudentSelect.vue'),
              meta: {
                centerSwitchRedirect: { name: 'admin.learn.report.index' },
              },
            },
            {
              name: 'admin.learn.report.focusAreaStudentView',
              path: 'student/:studentId',
              component: () =>
                import('components/learn/reports/focusArea/FocusAreaStudentReport.vue'),
              meta: {
                centerSwitchRedirect: { name: 'admin.learn.report.index' },
              },
            },
            {
              name: 'admin.learn.report.focusAreaGroup',
              path: 'group',
              component: () =>
                import('components/learn/reports/focusArea/FocusAreaGroupSelect.vue'),
              meta: {
                centerSwitchRedirect: { name: 'admin.learn.report.index' },
              },
            },
            {
              name: 'admin.learn.report.focusAreaGroupView',
              path: 'group/:groupId',
              component: () =>
                import('components/learn/reports/focusArea/FocusAreaGroupReport.vue'),
              meta: {
                centerSwitchRedirect: { name: 'admin.learn.report.index' },
              },
            },
          ],
        },
        {
          name: 'admin.learn.report.progress',
          path: 'progress',
          component: () =>
            import('components/learn/reports/progress/ProgressIndex.vue'),
          redirect: { name: 'admin.learn.report.progress.index' },
          children: [
            {
              name: 'admin.learn.report.progress.index',
              path: '',
              component: () =>
                import('components/learn/reports/progress/ProgressIndex.vue'),
              meta: {
                centerSwitchRedirect: { name: 'admin.learn.report.index' },
              },
            },
            {
              name: 'admin.learn.report.progressStudent',
              path: 'student',
              component: () =>
                import('components/learn/reports/progress/ProgressStudentSelect.vue'),
              meta: {
                centerSwitchRedirect: { name: 'admin.learn.report.index' },
              },
            },
            {
              name: 'admin.learn.report.progressStudentView',
              path: 'student/:studentId',
              component: () =>
                import('components/learn/reports/progress/ProgressStudentReport.vue'),
              meta: {
                centerSwitchRedirect: { name: 'admin.learn.report.index' },
              },
            },
            {
              name: 'admin.learn.report.progressGroup',
              path: 'group',
              component: () =>
                import('components/learn/reports/progress/ProgressGroupSelect.vue'),
              meta: {
                centerSwitchRedirect: { name: 'admin.learn.report.index' },
              },
            },
            {
              name: 'admin.learn.report.progressGroupView',
              path: 'group/:groupId',
              component: () =>
                import('components/learn/reports/progress/ProgressGroupReport.vue'),
              meta: {
                centerSwitchRedirect: { name: 'admin.learn.report.index' },
              },
            },
          ],
        },

        {
          name: 'admin.learn.report.shopping',
          path: 'shopping',
          component: () =>
            import('components/learn/reports/shopping/ShoppingIndex.vue'),
          redirect: { name: 'admin.learn.report.shopping.group.view' },
          children: [
            {
              name: 'admin.learn.report.shopping.group.view',
              path: 'view',
              component: () =>
                import('components/learn/reports/shopping/ShoppingListReport.vue'),
            },
          ],
        },
      ],
    },
    {
      name: 'admin.learn.setup',
      path: 'setup',
      component: () => import('components/learn/SetupIndex.vue'),
      meta: {
        roles: [Roles.SuperAdmin, Roles.OrgAdmin, Roles.CenterAdmin],
      },
    },
  ],
} as const satisfies RouteRecordRaw
